import { merge, $ } from "glamor";
import memoizeOne from "memoize-one";
import { theme } from "styles/theme";

const productCollectionGridViewStyles = memoizeOne((tileViewCardWidth: number = 0, rowGroupLength: number = 0) => {
    return merge(
        {
            padding: "8px 0 0",
            position: "relative",
            height: "100%",
        },
        $(" > div", {
            position: "absolute",
            top: "4px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            height: "auto !important",
        }),
        $(" .noValueRequired, .errorValidation", {
            backgroundColor: "#EF6865",
        }),
        $(" .noValueDesired, .warningValidation", {
            backgroundColor: "#FFD300",
        }),
        $(" .differentDepartment", {
            backgroundColor: theme.palette.errorColor,
        }),
        $(" .ag-cell", {
            paddingLeft: "8px !important",
            paddingRight: "8px !important",
            touchAction: "manipulation",
        }),
        $(" .ag-cell > .ag-react-container", {
            height: "100%",
            width: "100%",
        }),
        $(" .ag-react-container", {
            height: "100%",
            width: "100%",
        }),
        // * Note: Some visual regressions from ag-grid 19 -> 20 with the Image column cells
        $(" .ag-cell-value", {
            display: "flex",
            justifyContent: "flex-start",
        }),
        $(" .ag-cell.notes", {
            whiteSpace: "normal",
            lineHeight: "15px",
        }),
        $(".ag-theme-balham .ag-header-cell .ag-cell-label-container", {
            display: "flex",
        }),
        $(".ag-theme-balham .ag-ltr .ag-column-select-add-group-indent", {
            marginLeft: "0px",
        }),
        $(".ag-theme-balham .ag-row-drag .ag-icon-row-drag", {
            height: "100%",
            backgroundPositionY: "center",
        }),
        $(".ag-theme-balham span.ag-selection-checkbox", {
            display: "block",
            height: "100%",
            float: "left",
        }),
        $(".ag-theme-balham span.ag-selection-checkbox span", {
            position: "relative",
            top: "50%",
            transform: "translateY(calc(-50% - 1px))",
        }),
        // * Note: Some visual regressions from ag-grid 19 -> 20 with the Image column cells
        // * This is a selector that existed in 19 but went away in 20
        $(
            ".ag-theme-balham .ag-selection-checkbox span, .ag-theme-balham .ag-group-expanded span, .ag-theme-balham .ag-group-contracted span",
            {
                marginRight: "12px",
            }
        ),
        $(".ag-theme-balham .ag-column-select-column-readonly", {
            pointerEvents: "auto",
        }),
        $(".ag-theme-balham .ag-column-select-column-readonly .ag-column-select-column-label", {
            color: "#000",
        }),
        $(".ag-theme-balham .ag-popup-editor", {
            backgroundColor: "#fff",
        }),
        $(" .ag-cell .hashTag", {
            color: theme.palette.blue,
        }),
        $(" .ag-cell .hashTag:hover", {
            color: theme.palette.blue,
            textDecoration: "underline",
        }),
        $(" .ag-floating-filter-input, .ag-input-wrapper input", {
            lineHeight: "19px !important",
            paddingTop: "1px",
            paddingBottom: "1px",
        }),
        $(" .ag-floating-filter-input", {
            lineHeight: "19px",
        }),
        $(" .ag-pivot-mode-select", {
            // IE issue where label was expanding to next line
            width: "90px",
        }),
        $(" .ag-column-name-filter", {
            padding: "3px",
        }),
        $(" .ag-group-value", {
            display: "inline-block",
        }),
        $(" .ag-cell.integerCellClass", {
            textAlign: "right",
        }),
        $(" .ag-cell.currencyCellClass", {
            textAlign: "right",
        }),
        $(" .ag-cell.percentCellClass", {
            textAlign: "right",
        }),
        $(" .borderLeftClass", {
            borderLeft: `2px solid ${theme.grid.sectionSeparatorColor}`,
        }),
        $(".ag-theme-balham .ag-root", {
            border: `1px solid ${theme.palette.lightGrey}`,
            borderBottom: "none",
            borderLeft: "none",
        }),
        $(".ag-theme-balham .ag-tool-panel .ag-side-buttons", {
            borderBottom: "none",
        }),
        $(".ag-theme-balham .ag-tool-panel .ag-side-buttons button", {
            borderRight: `1px solid ${theme.palette.lightGrey}`,
        }),
        $(".ag-theme-balham .ag-tool-panel", {
            borderTop: `1px solid ${theme.palette.lightGrey}`,
        }),
        $(".ag-theme-balham .ag-header-row,.ag-theme-balham .ag-header", {
            borderBottom: `1px solid ${theme.palette.lightGrey}`,
        }),
        $(".ag-theme-balham .ag-floating-filter-button", {
            marginTop: "0px",
            height: "100%",
            display: "flex",
            alignItems: "center",
        }),
        $(".ag-theme-balham .ag-header-cell-label span", {
            display: "flex",
            alignItems: "center",
        }),
        $(" .ag-icon-checkbox-checked", {
            marginRight: "0px !important",
        }),
        $(" .ag-icon-checkbox-unchecked", {
            marginRight: "0px !important",
        }),
        $(".ag-theme-balham .ag-popup", {
            display: "contents !important",
        }),
        $(".ag-theme-balham .ag-tool-panel-wrapper .ag-column-panel .ag-column-drop:not(.ag-hidden):last-child", {
            borderBottom: 0,
        }),
        $(".ag-theme-balham .ag-side-bar .ag-side-buttons", {
            width: "100%",
            maxWidth: "20px",
            backgroundColor: theme.palette.lightGrey,
            overflowY: "auto",
        }),
        $(".isScrollVisible .ag-side-bar .ag-side-buttons", {
            maxWidth: "35px",
        }),
        $(" .ag-tool-panel-wrapper .ag-react-container", {
            width: "100%",
            height: "100%",
        }),
        $(" .ag-tool-panel-wrapper", {
            overflowX: "hidden",
        }),
        $(".ag-theme-balham .ag-ltr .ag-cell.ag-cell-last-left-pinned", {
            borderRight: "1px solid #BDC3C7",
        }),
        $(".ag-theme-balham .planCell", {
            position: "relative",
            height: "100%",
            textAlign: "right",
            overflow: "hidden",
        }),
        $(".ag-theme-balham .planCell .actualValue", {
            fontSize: "13px",
            lineHeight: "20px",
            height: "20px",
            color: theme.palette.darkestGrey,
            backgroundColor: "#ebebeb",
            fontWeight: "bold",
            fontStyle: "italic",
            margin: "3px 0 2px",
            padding: "0 4px",
        }),
        $(".ag-theme-balham .planCell .planValue", {
            marginTop: "1px",
            fontSize: "12px",
            lineHeight: "24px",
            height: "24px",
            color: theme.palette.darkestGrey,
            border: `solid 1px ${theme.palette.grey}`,
            backgroundColor: "white",
            padding: "0 4px",
        }),
        $(".ag-theme-balham .planCell .delta", {
            fontSize: "12px",
            lineHeight: "16px",
            height: "16px",
            color: theme.palette.darkestGrey,
            fontStyle: "italic",
            padding: "0 4px",
            marginTop: "4px",
            fontWeight: "bold",
        }),
        $(".ag-theme-balham .planCell .delta .great", {
            color: "#29dd2f",
        }),
        $(".ag-theme-balham .planCell .delta .fair", {
            color: "#C6C928",
        }),
        $(".ag-theme-balham .planCell .delta .off", {
            color: "#faa500",
        }),
        $(".ag-theme-balham .planCell .delta .wayOff", {
            color: "#e76161",
        }),
        $(".ag-theme-balham .doorsGroupTotal", {
            backgroundColor: `${theme.palette.lighterBlue} !important`,
        }),
        $(".ag-theme-balham .doorsGroupTotal--notEditable", {
            backgroundColor: theme.grid.headerBackgroundColor,
            color: "#a5a0a0",
        }),
        $(".ag-theme-balham .notEditable", {
            backgroundColor: theme.grid.headerBackgroundColor,
            color: "#a5a0a0",
        }),
        $(".ag-theme-balham .doorsGroupTotal--pinned", {
            backgroundColor: theme.grid.headerBackgroundColor,
        }),
        $(".ag-theme-balham .allocationDimensionTotal", {
            backgroundColor: `${theme.grid.totalAllocationDimensionColumn} !important`,
        }),
        $(".ag-theme-balham .doorsGroupClassification", {
            color: theme.palette.blue,
            fontSize: "11px",
            marginLeft: "2px",
            fontStyle: "italic",
        }),
        $(".ag-theme-balham .defaultValueHeader", {
            width: "100%",
        }),
        $(".ag-theme-balham .totalsRow", {
            fontWeight: "bold",
            fontSize: "12px",
        }),
        $(".ag-theme-balham .defaultValueHeader a", {
            color: theme.palette.darkGrey,
            fontSize: "11px",
            cursor: "pointer",
        }),
        $(" .planHeader", {
            display: "flex",
            width: "100%",
        }),
        $(" .planHeader .planTitle", {
            flexShrink: 1,
            flexGrow: 1,
            color: theme.palette.darkestGrey,
            fontWeight: "bold",
            fontSize: "11px",
        }),
        $(" .planHeader .planMetricType", {
            textAlign: "right",
            fontWeight: "normal",
            color: theme.palette.darkGrey,
        }),
        $(" .planHeader .diffMetricType", {
            textAlign: "right",
            color: theme.palette.darkGrey,
            fontWeight: "bold",
            fontStyle: "italic",
        }),
        $(" .planHeader .totalMetricType", {
            textAlign: "right",
            fontStyle: "italic",
        }),
        $(" .planHeader .totalMetricType span", {
            backgroundColor: "#ebebeb",
            color: theme.palette.darkGrey,
            fontWeight: "bold",
            padding: "2px 4px",
            fontSize: "12px",
        }),
        $(" .planHeader .planType", {
            textAlign: "left",
        }),
        $(" .planHeader .planRows", {
            flexShrink: 0,
            flexGrow: 0,
            margin: 0,
            padding: 0,
            textAlign: "right",
        }),
        $(" .planHeader .planRows .planLabel", {
            fontSize: "12px",
            color: theme.palette.darkGrey,
            lineHeight: "24px",
            height: "24px",
            padding: "0 4px",
        }),
        $(" .planHeader .planRows .actualLabel", {
            fontSize: "13px",
            lineHeight: "20px",
            height: "20px",
            color: theme.palette.darkGrey,
            backgroundColor: "#ebebeb",
            fontWeight: "bold",
            fontStyle: "italic",
            margin: "3px 0 2px",
            padding: "0 4px",
        }),
        $(" .planHeader .planRows .diffLabel", {
            fontSize: "12px",
            lineHeight: "16px",
            height: "16px",
            color: theme.palette.darkestGrey,
            fontStyle: "italic",
            padding: "0 4px",
        }),
        $(".ag-theme-balham .ag-floating-top", {
            backgroundColor: "#f5f7f7 !important",
        }),
        $(".ag-theme-balham .ag-floating-top .ag-row", {
            backgroundColor: "#f5f7f7 !important",
        }),
        $(" .ag-popup-editor.ag-ltr", {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: theme.palette.borderColor,
            boxShadow: `0 0 2px ${theme.palette.borderColor} !important`,
            borderRadius: "5px 5px 0 0",
        }),
        $(" .ag-cell-label-container span.note-arrow", {
            width: "10px",
            height: "10px",
            backgroundColor: "black",
            transform: "rotate(45deg)",
            position: "absolute",
            top: "-5px",
            right: "-5px",
        }),
        $(" .ag-icon.hidden-icon", {
            display: "none",
        }),
        $(".ag-theme-balham.tileMode .ag-row.ag-row-group", {
            width: "100%",
        }),
        $(".ag-theme-balham.tileMode .ag-row.ag-row-group.ag-row-group-expanded", {
            borderBottom: "none",
        }),
        $(".ag-theme-balham.tileMode .ag-row.ag-row-group.ag-row-group-expanded + .ag-row-group", {
            borderTop: "1px solid #d9dcde",
        }),
        $(".ag-theme-balham.tileMode .ag-row.ag-row-group .ag-group-value", {
            width: "100%",
        }),
        $(".ag-theme-balham.tileMode .ag-row:not(.ag-row-group)", {
            width: `${tileViewCardWidth + 3}px`, // 3 extra pixels to avoid to cut the box shadow
            borderWidth: 0,
        }),
        $(".ag-theme-balham.tileMode .ag-row:not(.ag-row-group).ag-row-hover", {
            background: "none",
        }),
        $(".ag-theme-balham.tileMode .ag-cell[col-id='ag-Grid-AutoColumn']", {
            left: "0 !important",
        }),
        $(".ag-theme-balham.tileMode .ag-cell-focus", {
            border: "none",
            backgroundColor: "transparent !important",
        }),
        $(".ag-theme-balham.tileMode .ag-row-loading", {
            height: "auto !important",
            minHeight: "25px",
        }),
        $(".ag-theme-balham.tileMode .ag-cell-wrapper.ag-cell-expandable.ag-row-group", {
            alignItems: "center",
            paddingLeft: "0",
        }),
        $(" .ag-header-group-cell.ag-header-active .ag-header-cell-menu-button", {
            opacity: 1,
        }),
        $(".ag-theme-balham.tileMode .ag-row", {
            whiteSpace: "normal",
            color: theme.palette.darkGrey,
            fontSize: "11px",
            lineHeight: "inherit",
            fontFamily: "'Lato', sans-serif",
        }),
        $(".ag-theme-balham.tileMode .ag-full-width-row .ag-cell-wrapper.ag-row-group", {
            lineHeight: "inherit",
            border: "none !important",
        }),
        $(".ag-theme-balham.tileMode .ag-body-horizontal-scroll.ag-scrollbar-invisible", {
            display: "none",
        }),
        ...Array(rowGroupLength)
            .fill(0)
            .map((_, index) =>
                $(`.ag-theme-balham.tileMode .ag-row-group.ag-row.ag-row-level-${index}`, {
                    paddingLeft: index === 0 ? "10px" : `${index * 30}px`,
                })
            )
    );
});

export default productCollectionGridViewStyles;
